export enum FieldInformationType {
  unknown,
  boolean,
  char,
  date,
  binary,
}
